import React from "react";

const MainSupportPage = () => {
  return <div>MainSupportPage</div>;
};

export default MainSupportPage;
